import React, { useRef, useState } from 'react';
import IconButton from '../../../shared/components/IconButton/IconButton';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { downloadRHCareerDocument, uploadRHCareerEvidence } from '../rh.api';

const resources = { education: 'educations', certification: 'certifications', training: 'trainings' };

export default function CareerEvidenceActions({ userId, kind, item, onChanged }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (!resources[kind] || !userId) return null;
  const hasEvidence = Boolean(item.documentPath || item.certificateFilePath);
  const upload = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    if (!['application/pdf', 'image/jpeg', 'image/png'].includes(file.type) || file.size > 5 * 1024 * 1024) {
      setError('Choisissez un fichier PDF, JPEG ou PNG de 5 Mo maximum.'); return;
    }
    setBusy(true); setError('');
    try { await uploadRHCareerEvidence(userId, resources[kind], item.id, file); await onChanged?.(); }
    catch (failure) { setError(failure.message || 'Le dépôt du justificatif a échoué.'); }
    finally { setBusy(false); }
  };
  const download = async () => {
    setBusy(true); setError('');
    try {
      const fileName = (item.documentPath || item.certificateFilePath).split('/').pop().replace(/^[a-f0-9-]{36}_/, '');
      await downloadRHCareerDocument(`/api/employee-profiles/${userId}/${resources[kind]}/${item.id}/evidence`, fileName);
    } catch (failure) { setError(failure.message || 'Le justificatif ne peut pas être téléchargé.'); }
    finally { setBusy(false); }
  };
  return <div className="rh-career-evidence">
    <input ref={input} type="file" accept="application/pdf,image/jpeg,image/png" onChange={upload} hidden aria-label="Fichier justificatif" />
    <IconButton size="small" ariaLabel={hasEvidence ? 'Remplacer le justificatif' : 'Joindre un justificatif'} tooltip={busy ? 'Dépôt ou chargement en cours…' : hasEvidence ? 'Remplacer le justificatif' : 'Joindre un justificatif'} disabled={busy} onClick={() => input.current?.click()}>{busy ? <HourglassEmptyIcon fontSize="small" /> : hasEvidence ? <UploadFileOutlinedIcon fontSize="small" /> : <AttachFileIcon fontSize="small" />}</IconButton>
    {hasEvidence && <IconButton size="small" tooltip="Télécharger le justificatif" disabled={busy} onClick={download}><FileDownloadOutlinedIcon fontSize="small" /></IconButton>}
    {busy && <span className="sr-only" role="status">Dépôt ou chargement en cours…</span>}
    {error && <p className="rh-form-error" role="alert">{error}</p>}
  </div>;
}
